"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.guidToString = guidToString;
exports.guidFromString = guidFromString;
exports.createEmptyGuid = createEmptyGuid;
exports.createGuid = createGuid;
exports.guidEquals = guidEquals;
const uuid_1 = require("uuid");
function guidToString(guid) {
    return guid.value;
}
function guidFromString(guid) {
    return {
        value: guid
    };
}
function createEmptyGuid() {
    return {
        value: "00000000-0000-0000-0000-000000000000"
    };
}
function createGuid() {
    return {
        value: (0, uuid_1.v4)()
    };
}
function guidEquals(a, b) {
    const g1 = isGuid(a) ? a : guidFromString(a);
    const g2 = isGuid(b) ? b : guidFromString(b);
    return g1.value.toUpperCase() === g2.value.toUpperCase();
}
function isGuid(value) {
    if (value.value && typeof value.value === "string") {
        return true;
    }
    return false;
}
//# sourceMappingURL=index.js.map